<div class="create-skills">
    <div class="create-skills-wrap">
        <div class="create-skills-left">
          <h2>Habilidades</h2>
        </div>

        <div class="create-skills-right">
            <a (click)="mostrarEdicionExperiencia()">+ Añadir Habilidad</a>
        </div>
    </div>

    <div>
        <div class="container" *ngIf="!mostrarEdicion">
          <div class="row" *ngFor="let habilidad of habilidades | paginate: { itemsPerPage: 1, currentPage: noPagina }">
              <div class="col-lg-6">
                  <div class="form-group">
                      <label>Tecnología</label>
                      <input type="text" class="form-control" [value]="habilidad.nombre" readonly>
                  </div>
              </div>

              <div class="col-lg-6">
                  <div class="skill">
                      <p>Porcentaje</p>
                      <div class="skill-bar skill1 skill3 wow slideInLeft animated " [style.width]="habilidad.nivel + '%'">
                          <span class="skill-count1">{{habilidad.nivel}}%</span>
                      </div>
                  </div>
              </div>

              <div class="col-lg-12">
                  <div class="form-group">
                      <label>Descripción</label>
                      <textarea class="form-control" [value]="habilidad.descripcion" readonly></textarea>
                  </div>
              </div>

              <div class="col-lg-12">
                  <div class="form-group">
                      <div class="text-left">
                          <button type="button" class="btn btn-default-ac" (click)="habilitarEdicion(habilidad)">Editar Actual</button>
                          <button type="button" class="btn btn-default-ac" (click)="eliminarHabilidad(habilidad.idHabilidad)">Eliminar Actual</button>
                      </div>
                  </div>
              </div>

              <div class="aling-center">
                  <pagination-controls class="page-numbers" (pageChange)="noPagina = $event"
                      [responsive]="true" [previousLabel]="''" [nextLabel]="''"></pagination-controls>
              </div>
          </div>
        </div>

        <div class="container" *ngIf="mostrarEdicion">
            <form [formGroup]="formHab" (ngSubmit)="validarHabilidad()">
                <div class="row">
                      <div class="col-lg-6">
                          <div class="form-group">
                              <label>Tecnologia</label>
                              <input type="text" class="form-control" formControlName="nombre" [placeholder]="habilidadCandidato.nombre || 'Desarrollador Front-End'">
                              <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formHab.controls.nombre.errors &&
                                  (formHab.controls.nombre.dirty || formHab.controls.nombre.touched)">
                                  <div *ngIf="formHab.controls.nombre.errors.required">El nombre de la tecnología es requerida.</div>
                              </div>
                          </div>
                      </div>

                      <div class="col-lg-6">
                          <div class="form-group">
                              <label>Nivel</label>
                              <input type="text" maxlength="3" max="100" class="form-control" formControlName="nivel" [placeholder]="habilidadCandidato.nivel || '80'">
                              <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formHab.controls.nivel.errors &&
                                  (formHab.controls.nivel.dirty || formHab.controls.nivel.touched)">
                                  <div *ngIf="formHab.controls.nivel.errors.required">El nivel es requerido.</div>
                                  <div *ngIf="formHab.controls.nivel.errors.pattern">Solo se permiten números.</div>
                                  <div *ngIf="formHab.controls.nivel.errors.maxlength">El nivel solo debe contener como máximo 3 dígitos.</div>
                              </div>
                          </div>
                      </div>

                      <div class="col-lg-12">
                          <div class="form-group">
                              <label>Descripción</label>
                              <textarea class="form-control" formControlName="descripcion" [placeholder]="habilidadCandidato.descripcion || 'Desarrollar aplicaciones Web en...'" style="height: 89px;"></textarea>
                              <div class="tw-px-4 tw-py-3 tw-rounded-xl tw-bg-red-50 tw-border tw-border-red-200 tw-text-sm tw-text-red-600 tw-mt-2" *ngIf="formHab.controls.descripcion.errors &&
                                  (formHab.controls.descripcion.dirty || formHab.controls.descripcion.touched)">
                                  <div *ngIf="formHab.controls.descripcion.errors.required">La descripcóon de la tecnología es requerida.</div>
                              </div>
                          </div>
                      </div>

                      <div class="col-lg-12">
                          <div class="form-group">
                              <div class="text-left">
                                  <button type="submit" class="btn create-ac-btn">{{(editarHabilidad ? 'Actualizar' : 'Agregar')}}</button>
                              </div>
                          </div>
                      </div>
                </div>
            </form>
        </div>
    </div>
</div>
